import React from 'react';
import { ILegaltransactionNote } from '../../Interfaces/ILegaltransactionNote';
import {
  Box,
  Button,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { NoteRow } from './NoteRow';

export interface IProps {
  notesArray: ILegaltransactionNote[];
  setNotesArray: Function;
}

const getEmptyNote = (notesArray: ILegaltransactionNote[]) => {
  let tmpId = -1;
  if (notesArray.length > 0) {
    const maxTmpId =
      Math.min(...notesArray.map(x => x.idLegalTransactionNote)) - 1;

    if (maxTmpId <= tmpId) {
      tmpId = maxTmpId - 1;
    }
  }

  return {
    idLegalTransaction: -1,
    idLegalTransactionNote: tmpId,
    idUser: -1,
    Note: '',
    Created_at: new Date().toISOString(),
    FirstName: 'Ich',
    LastName: '',
  } as ILegaltransactionNote;
};

export const NoteTab: React.FC<IProps> = ({ notesArray, setNotesArray }) => {
  const handleNew = () => {
    setNotesArray([getEmptyNote(notesArray), ...notesArray]);
  };

  return (
    <>
      <Typography sx={{ mt: 5 }} variant='h6'>
        Notizen
        <Button variant='outlined' sx={{ float: 'right' }} onClick={handleNew}>
          Neue Notiz
        </Button>
      </Typography>

      <Box sx={{ width: '100%', overflowX: 'auto' }}>
        <Table size='small' sx={{ tableLayout: 'fixed', width: '100%' }}>
          <TableHead>
            <TableRow>
              <TableCell sx={{ width: 150 }}>Datum</TableCell>
              <TableCell sx={{ width: 180 }}>Von</TableCell>
              <TableCell sx={{ wordWrap: 'break-word', whiteSpace: 'normal' }}>
                Notiz
              </TableCell>
              <TableCell sx={{ width: 25 }}></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {notesArray.map(note => (
              <NoteRow
                key={`note-${note.idLegalTransactionNote}`}
                note={note}
                noteArray={notesArray}
                setNoteArray={setNotesArray}
              />
            ))}
          </TableBody>
        </Table>
      </Box>
    </>
  );
};
